module.exports = __webpack_public_path__ + "public/img/出水温度.add9ca19.png";